var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('base-section',{attrs:{"id":"servicelist-account"}},[_c('v-container',[_c('v-row',{attrs:{"justify":"space-between"}},[_c('v-col',{attrs:{"cols":"12","md":"12"}},[_c('base-info-card',{attrs:{"title":_vm.$t('serviceSP.mainTitle')}}),_c('kdw-service-list-management')],1)],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }